const principles = [
  {
    icon: "ri-file-search-line",
    title: "先给证据，再下判断",
    desc: "票数快照、时间戳、公开记录优先。我们区分「已经发生的事实」与「尚未证实的推断」。",
  },
  {
    icon: "ri-shield-check-line",
    title: "不点名、不网暴",
    desc: "讨论的是打榜机制与数据现象，而不是把某个人钉在墙上。涉及个人时一律做模糊处理。",
  },
  {
    icon: "ri-refresh-line",
    title: "结论可以更新",
    desc: "当事方给出解释、数据得到复核后，我们会修改甚至推翻原来的说法。",
  },
];

const voices = [
  {
    name: "观赛老观众",
    role: "追了六年选美赛事",
    text: "以前只会跟着热搜骂，看完他们拆的票数曲线，才知道「异常」也要分情况看。",
  },
  {
    name: "后援会前管理员",
    role: "组织过两轮集资",
    text: "把账目该公开到什么程度讲得挺实在的，很多矛盾其实一开始就能避免。",
  },
  {
    name: "数据从业者",
    role: "关注榜单生态",
    text: "没有堆术语，账号结构和时段分析那几篇，普通读者也能看懂。",
  },
];

export default function VoiceSection() {
  return (
    <section className="px-4 md:px-6 xl:px-10 py-14 md:py-20">
      <div className="max-w-[1320px] mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-start">
          <div>
            <p className="text-xs tracking-[0.3em] text-primary-600 mb-2">HOW WE WORK</p>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
              吃瓜也要有方法
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600">
              我们关心的是「投票排名靠不靠谱」，而不是「谁该被骂」。因此每一篇内容都要遵守下面三条原则，
              如果你发现我们偏离了，欢迎直接来信指出。
            </p>

            <ul className="mt-8 flex flex-col gap-5">
              {principles.map((item) => (
                <li key={item.title} className="flex gap-4">
                  <span className="w-10 h-10 shrink-0 flex items-center justify-center rounded-md bg-secondary-100 text-secondary-800">
                    <i className={`${item.icon} text-lg`} />
                  </span>
                  <div>
                    <h3 className="font-heading text-base font-bold text-foreground-950">{item.title}</h3>
                    <p className="mt-1 text-sm leading-relaxed text-foreground-600">{item.desc}</p>
                  </div>
                </li>
              ))}
            </ul>
          </div>

          <div className="bg-background-100 rounded-lg p-6 md:p-8 border border-background-200">
            <div className="flex items-center gap-2 mb-6">
              <i className="ri-double-quotes-l text-3xl text-accent-500" />
              <h3 className="font-heading text-lg font-bold text-foreground-950">读者怎么说</h3>
            </div>
            <div className="flex flex-col gap-4">
              {voices.map((voice) => (
                <blockquote
                  key={voice.name}
                  className="bg-background-50 rounded-lg p-5 border border-background-200"
                >
                  <p className="text-sm leading-relaxed text-foreground-700">{voice.text}</p>
                  <footer className="mt-4 flex items-center gap-3">
                    <span className="w-8 h-8 flex items-center justify-center rounded-full bg-accent-100 text-accent-800 text-xs font-bold">
                      {voice.name.slice(0, 1)}
                    </span>
                    <span className="text-xs">
                      <span className="block font-medium text-foreground-900">{voice.name}</span>
                      <span className="block text-foreground-500">{voice.role}</span>
                    </span>
                  </footer>
                </blockquote>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}